import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'

import Step from '../../../../../../../../../features/components/Forms/StepForm/Step'
import UnitsField from './UnitsField'
import InventorySelectionRadioBlocks from '../../../../components/InventorySelectionRadioBlocks'
import InventoryOverviewSpoiler from '../../../../../components/InventoryOverviewSpoiler'

import { getUnitTypeLabel } from '../../../../formatters/formatUnitType'
import { useLineItemForecastData } from '../SubAllocationInventoryTargetingStep/RightInventoryTable/SubAllocationMultiFieldItem/useLineItemForecastData'
import { getAllOrSpecificInventory } from '../../../../helpers'
import { getIsBudgetAllocationType } from '../../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/helpers'

import { rightSelector } from '../../../../../../../../../modules/selectors/rights'

import { UNITS } from '../../../../fields'
import { BILLING_EVENT } from '../../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'

const SingleAllocationTargetingEnabledStep = ({ formik }) => {
  const { t } = useTranslation()

  const right = useSelector(rightSelector)
  const unitTypeLabel = getUnitTypeLabel(right[BILLING_EVENT])
  const { values } = formik

  const inventory = getAllOrSpecificInventory(values, right)
  const microAmount = inventory?.[0]?.prices?.[right?.billing_event]

  const { forecastErrorMessage } = useLineItemForecastData({
    values,
    inventory,
    microAmount,
    units: values[UNITS],
    targetingEnabled: false
  })

  const isBudgetAllocationType = getIsBudgetAllocationType(right)

  const title = useMemo(() => {
    return isBudgetAllocationType
      ? t('What budget do you want for this line item and do you want to target ad inventory with it?')
      : t(`What ${unitTypeLabel} budget do you want for this line item and do you want to target ad inventory with it?`)
  }, [t, isBudgetAllocationType, unitTypeLabel])

  return (
    <Step stepTitle={title}>
      <InventoryOverviewSpoiler />
      <InventorySelectionRadioBlocks
        formik={formik}
        allInventoryChildren={<UnitsField formik={formik} forecastErrorMessage={forecastErrorMessage} />}
        specificInventoryChildren={<UnitsField formik={formik} forecastErrorMessage={forecastErrorMessage} />}
      />
    </Step>
  )
}

export default SingleAllocationTargetingEnabledStep
